import { LOAD_SETTINGS, UPDATE_SETTINGS, NOTIFY_ACTION } from './constants';

export function loadSettings() {
  return {
    type: LOAD_SETTINGS,
  };
}

export function updateSettings(data) {
  return {
    type: UPDATE_SETTINGS,
    data,
  };
}

export function updateAlertState(fields) {
  return {
    type: NOTIFY_ACTION,
    fields,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-settings/actions.js
 **/